import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderPatientReminders: build.query<
      GetV2ProviderPatientRemindersApiResponse,
      GetV2ProviderPatientRemindersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patient-reminders`,
        params: {
          patient_id: queryArg.patientId,
        },
      }),
    }),
    patchV2ProviderPatientRemindersByPatientReminderId: build.mutation<
      PatchV2ProviderPatientRemindersByPatientReminderIdApiResponse,
      PatchV2ProviderPatientRemindersByPatientReminderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patient-reminders/${queryArg.patientReminderId}`,
        method: "PATCH",
        body: queryArg.updatePatientReminderCheckedRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderPatientRemindersApiResponse =
  /** status 200 OK */ PatientReminderListResponse;
export type GetV2ProviderPatientRemindersApiArg = {
  /** Patient ID to get reminders for */
  patientId: string;
};
export type PatchV2ProviderPatientRemindersByPatientReminderIdApiResponse =
  /** status 200 OK */ PatientReminderResponse2;
export type PatchV2ProviderPatientRemindersByPatientReminderIdApiArg = {
  patientReminderId: string;
  updatePatientReminderCheckedRequest: UpdatePatientReminderCheckedRequest;
};
export type PatientReminderResponse = {
  checked: boolean;
  created_at?: string | null;
  organization_id: string;
  patient_id: string;
  patient_reminder_id: string;
  reminder: string;
  updated_at?: string | null;
  user_id: string;
};
export type PatientReminderListResponse = {
  reminders: PatientReminderResponse[];
  /** Whether the frontend should render the session-reminders ad tile. Computed server-side from caller onboarding state, feature-flag eligibility, and whether the patient has an active intelligence brief component persisted. */
  show_ad?: boolean;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type PatientReminderResponse2 = {
  checked: boolean;
  created_at?: string | null;
  organization_id: string;
  patient_id: string;
  patient_reminder_id: string;
  reminder: string;
  updated_at?: string | null;
  user_id: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type UpdatePatientReminderCheckedRequest = {
  /** Whether the reminder is checked off */
  checked: boolean;
};
